import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { catchError, retry } from "rxjs/operators";
import { SystemUtils } from "../utils/system.utils";

@Component({
  selector: "app-master-template",
  templateUrl: "./master-template.component.html",
  styleUrls: ["./master-template.component.css"],
})
export class MasterTemplateComponent implements OnInit {
  levelName: any = "";
  description: any = "";
  isLevelNameEmpty: boolean = false;
  isDescriptionEmpty: boolean = false;
  isNewLevelModelShown: boolean = false;
  isLoading: boolean = false;

  isFailure: boolean = false;
  failureMessage: any = "";
  isSuccess: boolean = false;
  successMessage: any = "";

  environmentList: any = [];
  aliasName: any = "";
  addlevelName: any = "";
  adddescription: any = "";
  lid: any = "";
  cid: any = "";

  isAddLevelNameEmpty: boolean = false;
  isAddDescriptionEmpty: boolean = false;
  isAddChildLevelShown: boolean = false;
  isEditShown: boolean = false;
  isCatNameEdited: boolean = false;
  isCatDescEdit: boolean = false;

  systemList: any = [];
  permissionList: any = [];

  editCategoryId: any = "";
  editLevel: any = "";
  editParentId: any = "";
  editlevelName: any = "";
  editdescription: any = "";
  isEditLevelNameEmpty: boolean = false;
  isEditDescriptionEmpty: boolean = false;

  levelpath: any = [];

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    (this.isLoading = true),
      this._restService
        .environmentList()
        .pipe(
          catchError((e) => {
            (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.environmentList = f.EnvList),
            this.environmentList.map((f: any) => (f.isAliasEdited = false)),
            console.log("EEEEEEE", this.environmentList)
          )
        );

    this._restService
      .getsystemAccess("90", "1")
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.systemList = f.systemAccess),
          (SystemUtils.sortSystemAccess(this.systemList)),
          console.log("AC Lists ---->", this.systemList),
          this.systemList.map(
            (a: any) => (
              a.envList.map((m: any) => {
                m.pcrelation = a.categoryId;
              }),
              this.permissionList.push(a),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      b.envList.map((m: any) => {
                        m.pcrelation = b.categoryId;
                      }),
                      this.permissionList.push(b),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              c.envList.map((m: any) => {
                                m.pcrelation = c.categoryId;
                              }),
                              this.permissionList.push(c),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      d.envList.map((m: any) => {
                                        m.pcrelation = d.categoryId;
                                      }),
                                      this.permissionList.push(d),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) => (
                                              f.envList.map((m: any) => {
                                                m.pcrelation = f.categoryId;
                                              }),
                                              this.permissionList.push(f),
                                              f.hasOwnProperty("children")
                                                ? f.children.map(
                                                    (g: any) => (
                                                      g.envList.map(
                                                        (m: any) => {
                                                          m.pcrelation =
                                                            g.categoryId;
                                                        }
                                                      ),
                                                      this.permissionList.push(
                                                        g
                                                      ),
                                                      g.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? g.children.map(
                                                            (h: any) => (
                                                              h.envList.map(
                                                                (m: any) => {
                                                                  m.pcrelation =
                                                                    h.categoryId;
                                                                }
                                                              ),
                                                              this.permissionList.push(
                                                                h
                                                              ),
                                                              h.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? h.children.map(
                                                                    (
                                                                      j: any
                                                                    ) => (
                                                                      j.envList.map(
                                                                        (
                                                                          m: any
                                                                        ) => {
                                                                          m.pcrelation =
                                                                            j.categoryId;
                                                                        }
                                                                      ),
                                                                      this.permissionList.push(
                                                                        j
                                                                      ),
                                                                      j.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? j.children.map(
                                                                            (
                                                                              k: any
                                                                            ) => (
                                                                              k.envList.map(
                                                                                (
                                                                                  m: any
                                                                                ) => {
                                                                                  m.pcrelation =
                                                                                    k.categoryId;
                                                                                }
                                                                              ),
                                                                              this.permissionList.push(
                                                                                k
                                                                              ),
                                                                              k.hasOwnProperty(
                                                                                "children"
                                                                              )
                                                                                ? this.permissionList.push(
                                                                                    k
                                                                                  )
                                                                                : ""
                                                                            )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          ),
          (this.isLoading = false),
          console.log("PL 1", this.permissionList),
          console.log("categoryId Array------>>>", this.systemList),
          this.systemList.map(
            (a: any) => (
              a.envList.map((m: any) =>
                m.Visible !== true
                  ? this.disableChild(m.id, m.pcrelation, a.envList, a.children)
                  : ""
              ),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      b.envList.map((m: any) =>
                        m.Visible !== true
                          ? this.disableChild(
                              m.id,
                              m.pcrelation,
                              b.envList,
                              b.children
                            )
                          : ""
                      ),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              c.envList.map((m: any) =>
                                m.Visible !== true
                                  ? this.disableChild(
                                      m.id,
                                      m.pcrelation,
                                      c.envList,
                                      c.children
                                    )
                                  : ""
                              ),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      d.envList.map((m: any) =>
                                        m.Visible !== true
                                          ? this.disableChild(
                                              m.id,
                                              m.pcrelation,
                                              d.envList,
                                              d.children
                                            )
                                          : ""
                                      ),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) => (
                                              f.envList.map((m: any) =>
                                                m.Visible !== true
                                                  ? this.disableChild(
                                                      m.id,
                                                      m.pcrelation,
                                                      f.envList,
                                                      f.children
                                                    )
                                                  : ""
                                              ),
                                              f.hasOwnProperty("children")
                                                ? f.children.map(
                                                    (g: any) => (
                                                      g.envList.map((m: any) =>
                                                        m.Visible !== true
                                                          ? this.disableChild(
                                                              m.id,
                                                              m.pcrelation,
                                                              g.envList,
                                                              g.children
                                                            )
                                                          : ""
                                                      ),
                                                      g.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? g.children.map(
                                                            (h: any) => (
                                                              h.envList.map(
                                                                (m: any) =>
                                                                  m.Visible !==
                                                                  true
                                                                    ? this.disableChild(
                                                                        m.id,
                                                                        m.pcrelation,
                                                                        h.envList,
                                                                        h.children
                                                                      )
                                                                    : ""
                                                              ),
                                                              h.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? h.children.map(
                                                                    (
                                                                      j: any
                                                                    ) => (
                                                                      j.envList.map(
                                                                        (
                                                                          m: any
                                                                        ) =>
                                                                          m.Visible !==
                                                                          true
                                                                            ? this.disableChild(
                                                                                m.id,
                                                                                m.pcrelation,
                                                                                j.envList,
                                                                                j.children
                                                                              )
                                                                            : ""
                                                                      ),
                                                                      j.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? j.children.map(
                                                                            (
                                                                              k: any
                                                                            ) =>
                                                                              k.envList.map(
                                                                                (
                                                                                  m: any
                                                                                ) =>
                                                                                  m.Visible !==
                                                                                  true
                                                                                    ? this.disableChild(
                                                                                        m.id,
                                                                                        m.pcrelation,
                                                                                        k.envList,
                                                                                        k.children
                                                                                      )
                                                                                    : ""
                                                                              )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          )
        )
      );
  }

  disableChild(id: any, pcid: any, env: any, child: any) {
    let elist: any = env;
    let clist: any = child;

    console.log("elist", elist);
    console.log("clist", clist);

    clist.map(
      (a: any) => (
        a.envList.map((m: any) => (m.id === id ? (m.Visible = false) : "")),
        a.hasOwnProperty("children")
          ? a.children.map(
              (b: any) => (
                b.envList.map((m: any) =>
                  m.id === id ? (m.Visible = false) : ""
                ),
                b.hasOwnProperty("children")
                  ? b.children.map(
                      (c: any) => (
                        c.envList.map((m: any) =>
                          m.id === id ? (m.Visible = false) : ""
                        ),
                        c.hasOwnProperty("children")
                          ? c.children.map(
                              (d: any) => (
                                d.envList.map((m: any) =>
                                  m.id === id ? (m.Visible = false) : ""
                                ),
                                d.hasOwnProperty("children")
                                  ? d.children.map(
                                      (f: any) => (
                                        f.envList.map((m: any) =>
                                          m.id === id ? (m.Visible = false) : ""
                                        ),
                                        f.hasOwnProperty("children")
                                          ? f.children.map(
                                              (g: any) => (
                                                g.envList.map((m: any) =>
                                                  m.id === id
                                                    ? (m.Visible = false)
                                                    : ""
                                                ),
                                                g.hasOwnProperty("children")
                                                  ? g.children.map(
                                                      (h: any) => (
                                                        h.envList.map(
                                                          (m: any) =>
                                                            m.id === id
                                                              ? (m.Visible = false)
                                                              : ""
                                                        ),
                                                        h.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? h.children.map(
                                                              (j: any) => (
                                                                j.envList.map(
                                                                  (m: any) =>
                                                                    m.id === id
                                                                      ? (m.Visible = false)
                                                                      : ""
                                                                ),
                                                                j.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? j.children.map(
                                                                      (
                                                                        k: any
                                                                      ) => (
                                                                        k.envList.map(
                                                                          (
                                                                            m: any
                                                                          ) =>
                                                                            m.id ===
                                                                            id
                                                                              ? (m.Visible = false)
                                                                              : ""
                                                                        ),
                                                                        k.hasOwnProperty(
                                                                          "children"
                                                                        )
                                                                          ? k.children.map(
                                                                              (
                                                                                l: any
                                                                              ) =>
                                                                                l.envList.map(
                                                                                  (
                                                                                    m: any
                                                                                  ) =>
                                                                                    m.id ===
                                                                                    id
                                                                                      ? (m.Visible = false)
                                                                                      : ""
                                                                                )
                                                                            )
                                                                          : ""
                                                                      )
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  : ""
              )
            )
          : ""
      )
    );

    console.log("clist after", clist);
  }

  addLevelTwoSystem() {
    this.levelName = "";
    this.description = "";
    this.isNewLevelModelShown = true;

    let environmentList = this.environmentList;

    console.log("EnvironmentList ------>>>", environmentList);

    environmentList.filter(
      (f: any) => ((f.Alias = ""), (f.Visible = false), (f.isEdited = false))
    );
    this.environmentList = environmentList;
  }

  close() {
    this.isNewLevelModelShown = false;
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  onLevelName(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.levelName = ""),
        (this.isLevelNameEmpty = true))
      : (this.isLevelNameEmpty = false);
  }

  addNewLevel() {
    let levelName = this.levelName;
    let description = this.description;
    let environmentList = this.environmentList;

    this.levelName === ""
      ? (this.isLevelNameEmpty = true)
      : (this.isLevelNameEmpty = false);
    this.description === ""
      ? (this.isDescriptionEmpty = true)
      : (this.isDescriptionEmpty = false);

    if (this.levelName !== "" && this.description !== "") {
      let errorCount = this.checkingRequriedFeilds();

      if (errorCount === 0) {
        (this.isLoading = true),
          this._restService
            .addsystemAccess(levelName, description, environmentList, [])
            .pipe(
              catchError((e) => {
                (this.isLoading = false),
                  (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                console.log("Onload Error --->", e.error);
                return e;
              })
            )
            .subscribe((f: any) => {
              (this.isLoading = false),
                (this.isSuccess = true),
                (this.successMessage = f.StatusInfo),
                (this.isNewLevelModelShown = false),
                (this.environmentList = environmentList),
                this.environmentList.map((f: any) => (f.isAliasEdited = false)),
                this._restService
                  .getsystemAccess("90", "1")
                  .pipe(
                    catchError((e) => {
                      (this.isFailure = true),
                        (this.failureMessage = e.error.StatusInfo);
                      console.log("Onload Error --->", e.error);
                      return e;
                    })
                  )
                  .subscribe(
                    (f: any) => (
                      (this.systemList = f.systemAccess),
                      (SystemUtils.sortSystemAccess(this.systemList)),
                      (this.permissionList = []),
                      this.systemList.map(
                        (a: any) => (
                          this.permissionList.push(a),
                          a.hasOwnProperty("children")
                            ? a.children.map(
                                (b: any) => (
                                  this.permissionList.push(b),
                                  b.hasOwnProperty("children")
                                    ? b.children.map(
                                        (c: any) => (
                                          this.permissionList.push(c),
                                          c.hasOwnProperty("children")
                                            ? c.children.map(
                                                (d: any) => (
                                                  this.permissionList.push(d),
                                                  d.hasOwnProperty("children")
                                                    ? d.children.map(
                                                        (f: any) => (
                                                          this.permissionList.push(
                                                            f
                                                          ),
                                                          f.hasOwnProperty(
                                                            "children"
                                                          )
                                                            ? f.children.map(
                                                                (g: any) => (
                                                                  this.permissionList.push(
                                                                    g
                                                                  ),
                                                                  g.hasOwnProperty(
                                                                    "children"
                                                                  )
                                                                    ? g.children.map(
                                                                        (
                                                                          h: any
                                                                        ) => (
                                                                          this.permissionList.push(
                                                                            h
                                                                          ),
                                                                          h.hasOwnProperty(
                                                                            "children"
                                                                          )
                                                                            ? h.children.map(
                                                                                (
                                                                                  j: any
                                                                                ) => (
                                                                                  this.permissionList.push(
                                                                                    j
                                                                                  ),
                                                                                  j.hasOwnProperty(
                                                                                    "children"
                                                                                  )
                                                                                    ? j.children.map(
                                                                                        (
                                                                                          k: any
                                                                                        ) => (
                                                                                          this.permissionList.push(
                                                                                            k
                                                                                          ),
                                                                                          k.hasOwnProperty(
                                                                                            "children"
                                                                                          )
                                                                                            ? this.permissionList.push(
                                                                                                k
                                                                                              )
                                                                                            : ""
                                                                                        )
                                                                                      )
                                                                                    : ""
                                                                                )
                                                                              )
                                                                            : ""
                                                                        )
                                                                      )
                                                                    : ""
                                                                )
                                                              )
                                                            : ""
                                                        )
                                                      )
                                                    : ""
                                                )
                                              )
                                            : ""
                                        )
                                      )
                                    : ""
                                )
                              )
                            : ""
                        )
                      )
                    )
                  );
            });
      } else {
        (this.isFailure = true),
          (this.failureMessage = "Enter the all required fields");
      }
    }
  }

  checkingRequriedFeilds() {
    let isErrorOccur = 0;
    let environmentList = this.environmentList;

    environmentList.map((f: any) =>
      f.Visible === true && f.Alias === ""
        ? (isErrorOccur = isErrorOccur + 1)
        : ""
    );

    return isErrorOccur;
  }

  onDescription(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.description = ""),
        (this.isDescriptionEmpty = true))
      : (this.isDescriptionEmpty = false);
  }

  onLeaveNameBlur(e: any) {
    let levelname = e.target.value;
    let environmentList = this.environmentList;
    environmentList.map((f: any) => (f.Alias = levelname));
  }

  aliasEnvironment(e: any, id: any) {
    let environmentList = this.environmentList;
    environmentList.map((f: any) =>
      f.id === id ? (f.Alias = e.target.value) : ""
    );
    this.environmentList = environmentList;
  }

  onChangeAliasEnvironment(id: any) {
    this.environmentList.map((f: any) =>
      f.id === id ? (f.isAliasEdited = true) : ""
    );
  }

  environmentVisible(e: any, id: any) {
    let environmentList = this.environmentList;

    environmentList.map((f: any) => {
      f.id === id
        ? ((f.Visible = e.target.checked), (f.isEdited = e.target.checked))
        : "";
    });

    environmentList.map((f: any) => {
      f.id === id ? (f.isEnvEdited = true) : "";
    });

    this.environmentList = environmentList;

    console.log("ID --->>", id);
    console.log("Environment Visible", this.environmentList);
  }

  addNewChildLevel(lid: any, cid: any) {
    this.isLoading = true;
    this.lid = lid;
    this.cid = cid;
    this.addlevelName = "";
    this.adddescription = "";
    this.levelpath = [];
    this.environmentList = [];

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.environmentList = f.EnvList), console.log(this.environmentList)
        )
      );

    this._restService
      .getParentList(this.cid)
      .pipe(
        catchError((e) => {
          (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo),
            (this.isLoading = false);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("parentList", f.parentList),
          (this.isLoading = false),
          (this.levelpath = f.parentList),
          (this.isAddChildLevelShown = true)
        )
      );
  }

  onAddLevelName(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.addlevelName = ""),
        (this.isAddLevelNameEmpty = true))
      : (this.isAddLevelNameEmpty = false);
  }

  onAddDescription(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.adddescription = ""),
        (this.isAddDescriptionEmpty = true))
      : (this.isAddDescriptionEmpty = false);
  }

  saveNewLevelChild() {
    console.log("this.environmentList", this.environmentList);

    this.addlevelName === ""
      ? (this.isAddLevelNameEmpty = true)
      : (this.isAddLevelNameEmpty = false);
    this.adddescription === ""
      ? (this.isAddDescriptionEmpty = true)
      : (this.isAddDescriptionEmpty = false);

    if (this.addlevelName !== "" && this.adddescription !== "") {
      (this.isAddChildLevelShown = false),
        (this.isLoading = true),
        this._restService
          .addsystemAccessLevel(
            this.lid,
            this.cid,
            this.addlevelName,
            this.adddescription,
            this.environmentList,
            this.levelpath
          )
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              console.log(f),
              (this.isLoading = false),
              (this.isSuccess = true),
              (this.successMessage = f.StatusInfo),
              this._restService
                .getsystemAccess("90", "1")
                .pipe(
                  catchError((e) => {
                    (this.isFailure = true),
                      (this.failureMessage = e.error.StatusInfo);
                    console.log("Onload Error --->", e.error);
                    return e;
                  })
                )
                .subscribe(
                  (f: any) => (
                    (this.systemList = []),
                    (this.systemList = f.systemAccess),
                    (SystemUtils.sortSystemAccess(this.systemList)),
                    console.log("Check list", f),
                    (this.permissionList = []),
                    this.systemList.map(
                      (a: any) => (
                        this.permissionList.push(a),
                        a.hasOwnProperty("children")
                          ? a.children.map(
                              (b: any) => (
                                this.permissionList.push(b),
                                b.hasOwnProperty("children")
                                  ? b.children.map(
                                      (c: any) => (
                                        this.permissionList.push(c),
                                        c.hasOwnProperty("children")
                                          ? c.children.map(
                                              (d: any) => (
                                                this.permissionList.push(d),
                                                d.hasOwnProperty("children")
                                                  ? d.children.map(
                                                      (f: any) => (
                                                        this.permissionList.push(
                                                          f
                                                        ),
                                                        f.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? f.children.map(
                                                              (g: any) => (
                                                                this.permissionList.push(
                                                                  g
                                                                ),
                                                                g.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? g.children.map(
                                                                      (
                                                                        h: any
                                                                      ) => (
                                                                        this.permissionList.push(
                                                                          h
                                                                        ),
                                                                        h.hasOwnProperty(
                                                                          "children"
                                                                        )
                                                                          ? h.children.map(
                                                                              (
                                                                                j: any
                                                                              ) => (
                                                                                this.permissionList.push(
                                                                                  j
                                                                                ),
                                                                                j.hasOwnProperty(
                                                                                  "children"
                                                                                )
                                                                                  ? j.children.map(
                                                                                      (
                                                                                        k: any
                                                                                      ) => (
                                                                                        this.permissionList.push(
                                                                                          k
                                                                                        ),
                                                                                        k.hasOwnProperty(
                                                                                          "children"
                                                                                        )
                                                                                          ? this.permissionList.push(
                                                                                              k
                                                                                            )
                                                                                          : ""
                                                                                      )
                                                                                    )
                                                                                  : ""
                                                                              )
                                                                            )
                                                                          : ""
                                                                      )
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  )
                )
            )
          );
    }
  }

  titleScrollbar() {
    var wrapper1 = document.getElementById("titleScroll");
    var wrapper2 = document.getElementById("contentScrollbar");
    wrapper2.scrollLeft = wrapper1.scrollLeft;
  }

  contentScrollbar() {
    var wrapper1 = document.getElementById("titleScroll");
    var wrapper2 = document.getElementById("contentScrollbar");
    wrapper1.scrollLeft = wrapper2.scrollLeft;
  }

  deleteChildLevel(id: any) {
    this._restService
      .deleteSystemAccess(id)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          this._restService
            .getsystemAccess("90", "1")
            .pipe(
              catchError((e) => {
                (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                console.log("Onload Error --->", e.error);
                return e;
              })
            )
            .subscribe(
              (f: any) => (
                (this.systemList = f.systemAccess),
                (SystemUtils.sortSystemAccess(this.systemList)),
                (this.permissionList = []),
                this.systemList.map(
                  (a: any) => (
                    this.permissionList.push(a),
                    a.hasOwnProperty("children")
                      ? a.children.map(
                          (b: any) => (
                            this.permissionList.push(b),
                            b.hasOwnProperty("children")
                              ? b.children.map(
                                  (c: any) => (
                                    this.permissionList.push(c),
                                    c.hasOwnProperty("children")
                                      ? c.children.map(
                                          (d: any) => (
                                            this.permissionList.push(d),
                                            d.hasOwnProperty("children")
                                              ? d.children.map(
                                                  (f: any) => (
                                                    this.permissionList.push(f),
                                                    f.hasOwnProperty("children")
                                                      ? f.children.map(
                                                          (g: any) => (
                                                            this.permissionList.push(
                                                              g
                                                            ),
                                                            g.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? g.children.map(
                                                                  (h: any) => (
                                                                    this.permissionList.push(
                                                                      h
                                                                    ),
                                                                    h.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? h.children.map(
                                                                          (
                                                                            j: any
                                                                          ) => (
                                                                            this.permissionList.push(
                                                                              j
                                                                            ),
                                                                            j.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? j.children.map(
                                                                                  (
                                                                                    k: any
                                                                                  ) => (
                                                                                    this.permissionList.push(
                                                                                      k
                                                                                    ),
                                                                                    k.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? this.permissionList.push(
                                                                                          k
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              )
            )
        )
      );
  }

  addModelClose() {
    this.isAddChildLevelShown = false;
  }

  editsystemAccess(
    categoryId: any,
    category_Name: any,
    Description: any,
    LevelNumber: any,
    parentId: any,
    envList: any
  ) {
    console.log("Edit level", this.systemList);

    this.editCategoryId = categoryId;
    this.editLevel = LevelNumber;
    this.editParentId = parentId;
    this.editlevelName = category_Name;
    this.editdescription = Description;
    let envArray = [];

    envList.filter((f: any) =>
      f.Alias === ""
        ? ((f.Alias = category_Name), envArray.push(f))
        : envArray.push(f)
    );

    this.environmentList = envArray;
    this.environmentList.map((f: any) => (f.isAliasEdited = false)),
      console.log("IsTrue ---->>>", envList);
    console.log("LevelNumber --->>>", LevelNumber);
    console.log("Category Name --->>>", category_Name);
    console.log("Env Array --->>>", envArray);

    this.levelpath = [];
    (this.isLoading = true),
      this._restService
        .getParentList(categoryId)
        .pipe(
          catchError((e) => {
            (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo),
              (this.isLoading = false);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("parentList", f.parentList),
            (this.isLoading = false),
            (this.levelpath = f.parentList),
            (this.isEditShown = true)
          )
        );

    console.log("envListenvListenvList", envList);
  }

  editModelClose() {
    this.isEditShown = false;
    this.isLoading = true;
    this._restService
      .getsystemAccess("90", "1")
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.systemList = []),
          (this.permissionList = []),
          (this.systemList = f.systemAccess),
          (SystemUtils.sortSystemAccess(this.systemList)),
          console.log("AC Lists ---->", this.systemList),
          this.systemList.map(
            (a: any) => (
              a.envList.map((m: any) => {
                m.pcrelation = a.categoryId;
              }),
              this.permissionList.push(a),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      b.envList.map((m: any) => {
                        m.pcrelation = b.categoryId;
                      }),
                      this.permissionList.push(b),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              c.envList.map((m: any) => {
                                m.pcrelation = c.categoryId;
                              }),
                              this.permissionList.push(c),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      d.envList.map((m: any) => {
                                        m.pcrelation = d.categoryId;
                                      }),
                                      this.permissionList.push(d),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) => (
                                              f.envList.map((m: any) => {
                                                m.pcrelation = f.categoryId;
                                              }),
                                              this.permissionList.push(f),
                                              f.hasOwnProperty("children")
                                                ? f.children.map(
                                                    (g: any) => (
                                                      g.envList.map(
                                                        (m: any) => {
                                                          m.pcrelation =
                                                            g.categoryId;
                                                        }
                                                      ),
                                                      this.permissionList.push(
                                                        g
                                                      ),
                                                      g.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? g.children.map(
                                                            (h: any) => (
                                                              h.envList.map(
                                                                (m: any) => {
                                                                  m.pcrelation =
                                                                    h.categoryId;
                                                                }
                                                              ),
                                                              this.permissionList.push(
                                                                h
                                                              ),
                                                              h.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? h.children.map(
                                                                    (
                                                                      j: any
                                                                    ) => (
                                                                      j.envList.map(
                                                                        (
                                                                          m: any
                                                                        ) => {
                                                                          m.pcrelation =
                                                                            j.categoryId;
                                                                        }
                                                                      ),
                                                                      this.permissionList.push(
                                                                        j
                                                                      ),
                                                                      j.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? j.children.map(
                                                                            (
                                                                              k: any
                                                                            ) => (
                                                                              k.envList.map(
                                                                                (
                                                                                  m: any
                                                                                ) => {
                                                                                  m.pcrelation =
                                                                                    k.categoryId;
                                                                                }
                                                                              ),
                                                                              this.permissionList.push(
                                                                                k
                                                                              ),
                                                                              k.hasOwnProperty(
                                                                                "children"
                                                                              )
                                                                                ? this.permissionList.push(
                                                                                    k
                                                                                  )
                                                                                : ""
                                                                            )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          ),
          (this.isLoading = false),
          console.log("PL 1", this.permissionList),
          console.log("categoryId Array------>>>", this.systemList),
          this.systemList.map(
            (a: any) => (
              a.envList.map((m: any) =>
                m.Visible !== true
                  ? this.disableChild(m.id, m.pcrelation, a.envList, a.children)
                  : ""
              ),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      b.envList.map((m: any) =>
                        m.Visible !== true
                          ? this.disableChild(
                              m.id,
                              m.pcrelation,
                              b.envList,
                              b.children
                            )
                          : ""
                      ),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              c.envList.map((m: any) =>
                                m.Visible !== true
                                  ? this.disableChild(
                                      m.id,
                                      m.pcrelation,
                                      c.envList,
                                      c.children
                                    )
                                  : ""
                              ),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      d.envList.map((m: any) =>
                                        m.Visible !== true
                                          ? this.disableChild(
                                              m.id,
                                              m.pcrelation,
                                              d.envList,
                                              d.children
                                            )
                                          : ""
                                      ),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) => (
                                              f.envList.map((m: any) =>
                                                m.Visible !== true
                                                  ? this.disableChild(
                                                      m.id,
                                                      m.pcrelation,
                                                      f.envList,
                                                      f.children
                                                    )
                                                  : ""
                                              ),
                                              f.hasOwnProperty("children")
                                                ? f.children.map(
                                                    (g: any) => (
                                                      g.envList.map((m: any) =>
                                                        m.Visible !== true
                                                          ? this.disableChild(
                                                              m.id,
                                                              m.pcrelation,
                                                              g.envList,
                                                              g.children
                                                            )
                                                          : ""
                                                      ),
                                                      g.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? g.children.map(
                                                            (h: any) => (
                                                              h.envList.map(
                                                                (m: any) =>
                                                                  m.Visible !==
                                                                  true
                                                                    ? this.disableChild(
                                                                        m.id,
                                                                        m.pcrelation,
                                                                        h.envList,
                                                                        h.children
                                                                      )
                                                                    : ""
                                                              ),
                                                              h.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? h.children.map(
                                                                    (
                                                                      j: any
                                                                    ) => (
                                                                      j.envList.map(
                                                                        (
                                                                          m: any
                                                                        ) =>
                                                                          m.Visible !==
                                                                          true
                                                                            ? this.disableChild(
                                                                                m.id,
                                                                                m.pcrelation,
                                                                                j.envList,
                                                                                j.children
                                                                              )
                                                                            : ""
                                                                      ),
                                                                      j.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? j.children.map(
                                                                            (
                                                                              k: any
                                                                            ) =>
                                                                              k.envList.map(
                                                                                (
                                                                                  m: any
                                                                                ) =>
                                                                                  m.Visible !==
                                                                                  true
                                                                                    ? this.disableChild(
                                                                                        m.id,
                                                                                        m.pcrelation,
                                                                                        k.envList,
                                                                                        k.children
                                                                                      )
                                                                                    : ""
                                                                              )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          )
        )
      );
  }

  onEditLevelName(e: any) {
    this.isCatNameEdited = true;

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.editlevelName = ""),
        (this.isEditLevelNameEmpty = true))
      : (this.isEditLevelNameEmpty = false);
  }

  onEditDescription(e: any) {
    this.isCatDescEdit = true;

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.editdescription = ""),
        (this.isEditDescriptionEmpty = true))
      : (this.isEditDescriptionEmpty = false);
  }

  updateLevelData(e: any) {
    this.editlevelName === ""
      ? (this.isEditLevelNameEmpty = true)
      : (this.isEditLevelNameEmpty = false);
    this.editdescription === ""
      ? (this.isEditDescriptionEmpty = true)
      : (this.isEditDescriptionEmpty = false);

    if (this.editlevelName !== "" && this.editdescription !== "") {
      let errorCount = this.editLevel === 1 ? this.checkingRequriedFeilds() : 0;

      if (errorCount === 0) {
        this.isEditShown = false;
        this.isLoading = true;
        this._restService
          .editsystemAccess(
            this.editCategoryId,
            this.editlevelName,
            this.editdescription,
            this.editLevel,
            this.editParentId,
            this.levelpath,
            this.environmentList,
            this.isCatNameEdited,
            this.isCatDescEdit
          )
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe((f: any) =>
            this._restService
              .getsystemAccess("90", "1")
              .pipe(
                catchError((e) => {
                  (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  console.log("Edit SystemAccess ---->>>", f.systemAccess),
                  (this.systemList = f.systemAccess),
                  (SystemUtils.sortSystemAccess(this.systemList)),
                  (this.permissionList = []),
                  this.systemList.map(
                    (a: any) => (
                      this.permissionList.push(a),
                      a.hasOwnProperty("children")
                        ? a.children.map(
                            (b: any) => (
                              this.permissionList.push(b),
                              b.hasOwnProperty("children")
                                ? b.children.map(
                                    (c: any) => (
                                      this.permissionList.push(c),
                                      c.hasOwnProperty("children")
                                        ? c.children.map(
                                            (d: any) => (
                                              this.permissionList.push(d),
                                              d.hasOwnProperty("children")
                                                ? d.children.map(
                                                    (f: any) => (
                                                      this.permissionList.push(
                                                        f
                                                      ),
                                                      f.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? f.children.map(
                                                            (g: any) => (
                                                              this.permissionList.push(
                                                                g
                                                              ),
                                                              g.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? g.children.map(
                                                                    (
                                                                      h: any
                                                                    ) => (
                                                                      this.permissionList.push(
                                                                        h
                                                                      ),
                                                                      h.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? h.children.map(
                                                                            (
                                                                              j: any
                                                                            ) => (
                                                                              this.permissionList.push(
                                                                                j
                                                                              ),
                                                                              j.hasOwnProperty(
                                                                                "children"
                                                                              )
                                                                                ? j.children.map(
                                                                                    (
                                                                                      k: any
                                                                                    ) => (
                                                                                      this.permissionList.push(
                                                                                        k
                                                                                      ),
                                                                                      k.hasOwnProperty(
                                                                                        "children"
                                                                                      )
                                                                                        ? this.permissionList.push(
                                                                                            k
                                                                                          )
                                                                                        : ""
                                                                                    )
                                                                                  )
                                                                                : ""
                                                                            )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  ),
                  (this.isLoading = false),
                  this.systemList.map(
                    (a: any) => (
                      a.envList.map((m: any) =>
                        m.Visible !== true
                          ? this.disableChild(
                              m.id,
                              m.pcrelation,
                              a.envList,
                              a.children
                            )
                          : ""
                      ),
                      a.hasOwnProperty("children")
                        ? a.children.map(
                            (b: any) => (
                              b.envList.map((m: any) =>
                                m.Visible !== true
                                  ? this.disableChild(
                                      m.id,
                                      m.pcrelation,
                                      b.envList,
                                      b.children
                                    )
                                  : ""
                              ),
                              b.hasOwnProperty("children")
                                ? b.children.map(
                                    (c: any) => (
                                      c.envList.map((m: any) =>
                                        m.Visible !== true
                                          ? this.disableChild(
                                              m.id,
                                              m.pcrelation,
                                              c.envList,
                                              c.children
                                            )
                                          : ""
                                      ),
                                      c.hasOwnProperty("children")
                                        ? c.children.map(
                                            (d: any) => (
                                              d.envList.map((m: any) =>
                                                m.Visible !== true
                                                  ? this.disableChild(
                                                      m.id,
                                                      m.pcrelation,
                                                      d.envList,
                                                      d.children
                                                    )
                                                  : ""
                                              ),
                                              d.hasOwnProperty("children")
                                                ? d.children.map(
                                                    (f: any) => (
                                                      f.envList.map((m: any) =>
                                                        m.Visible !== true
                                                          ? this.disableChild(
                                                              m.id,
                                                              m.pcrelation,
                                                              f.envList,
                                                              f.children
                                                            )
                                                          : ""
                                                      ),
                                                      f.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? f.children.map(
                                                            (g: any) => (
                                                              g.envList.map(
                                                                (m: any) =>
                                                                  m.Visible !==
                                                                  true
                                                                    ? this.disableChild(
                                                                        m.id,
                                                                        m.pcrelation,
                                                                        g.envList,
                                                                        g.children
                                                                      )
                                                                    : ""
                                                              ),
                                                              g.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? g.children.map(
                                                                    (
                                                                      h: any
                                                                    ) => (
                                                                      h.envList.map(
                                                                        (
                                                                          m: any
                                                                        ) =>
                                                                          m.Visible !==
                                                                          true
                                                                            ? this.disableChild(
                                                                                m.id,
                                                                                m.pcrelation,
                                                                                h.envList,
                                                                                h.children
                                                                              )
                                                                            : ""
                                                                      ),
                                                                      h.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? h.children.map(
                                                                            (
                                                                              j: any
                                                                            ) => (
                                                                              j.envList.map(
                                                                                (
                                                                                  m: any
                                                                                ) =>
                                                                                  m.Visible !==
                                                                                  true
                                                                                    ? this.disableChild(
                                                                                        m.id,
                                                                                        m.pcrelation,
                                                                                        j.envList,
                                                                                        j.children
                                                                                      )
                                                                                    : ""
                                                                              ),
                                                                              j.hasOwnProperty(
                                                                                "children"
                                                                              )
                                                                                ? j.children.map(
                                                                                    (
                                                                                      k: any
                                                                                    ) =>
                                                                                      k.envList.map(
                                                                                        (
                                                                                          m: any
                                                                                        ) =>
                                                                                          m.Visible !==
                                                                                          true
                                                                                            ? this.disableChild(
                                                                                                m.id,
                                                                                                m.pcrelation,
                                                                                                k.envList,
                                                                                                k.children
                                                                                              )
                                                                                            : ""
                                                                                      )
                                                                                  )
                                                                                : ""
                                                                            )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                )
              )
          );
      } else {
        (this.isFailure = true),
          (this.failureMessage = "Enter the all required fields");
      }
    }
  }
}
